import { Card } from 'antd';
import AdminSidebar from '../Components/Sidebar';
import { getProvidersList } from '../redux/slices/adminSlice';
import { useNavigate } from 'react-router';
import TableComponent from '../Components/TableComponent';
import { getAppointmentList } from '../redux/slices/appointmentSlice';

function AppointmentList() {
    const navigate = useNavigate()

    const columns = [
        {
            title: 'User Name',
            dataIndex: 'user_name',
            key: 'user_name',
        },
        {
            title: 'Provider Name',
            dataIndex: 'provider_name',
            key: 'provider_name',
        },
        {
            title: 'Start Time',
            dataIndex: 'start_time',
            key: 'start_time',
        },
        {
            title: 'End Time',
            dataIndex: 'end_time',
            key: 'end_time',
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Amount',
            dataIndex: 'transaction',
            key: 'transaction',
        },
        {
            title: 'Action',
            dataIndex: 'key',
            key: 'key',
            render: (_, record) => <a onClick={() => viewData(record?.key)}>View</a>,
        },
    ];

    const viewData = async (id) => {
        navigate(`/admin/appointment/${id}`)
    }

    return (
        <>
            <AdminSidebar renderContent={
                <Card
                    title="Appointment"
                    style={{ marginBottom: 24 }}
                >
                    <TableComponent
                        listData={getAppointmentList}
                        columns={columns}
                        placeholder="Search appointments..."
                    />
                </Card>
            } />

        </>
    );
}

export default AppointmentList;